<template>
<label class="z-checkbox">
  <input type="checkbox" :checked="value" class="checkbox-input" @change="onChange" />
  <span
    :class="{
      indeterminate
    }"
    class="checkbox-display"
  ></span>
</label>
</template>

<script>
export default {
  name: 'ZCheckbox',
  props: {
    value: {
      type: Boolean
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange (event) {
      let {checked} = event.target
      this.$emit('input', checked)
      this.$emit('change', checked)
    }
  }
}
</script>

<style lang="scss">
.z-checkbox {
  font-size: 0;
  display: inline-block;
  width: 14px;
  height: 14px;
  overflow: hidden;
  cursor: pointer;

  > .checkbox-input {
    position: absolute;
    visibility: hidden;
    opacity: 0;

    &:checked {
      & + .checkbox-display {
        border-color: #409eff;
        background-color: #409eff;
      }
    }
  }

  > .checkbox-display {
    display: block;
    float: left;
    width: 100%;
    height: 100%;
    border: 1px solid #dcdfe6;
    transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);

    &.indeterminate {
      background-color: #409eff;
      border-color: #409eff;

      &:before {
        content: "";
        display: block;
        width: 50%;
        height: 1px;
        margin: 5px 0 0 3px;
        background-color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ZTable/ZCheckbox.vue